import { IconInfoCircle } from '@tabler/icons-react'
import { Tooltip } from 'react-tooltip'
import { classNames } from 'util/classNames'

export const HelperIcon = ({
  id,
  helper,
  className,
}: {
  id: string
  helper: string
  className?: string
}) => {
  return (
    <>
      <Tooltip
        className="max-w-xs whitespace-normal"
        variant="dark"
        content={helper}
        id={id}
      />
      <IconInfoCircle
        className={classNames('inline-block', className)}
        data-tooltip-id={id}
      />
    </>
  )
}
